import { render, staticRenderFns } from "./ExtraInformationForRide.vue?vue&type=template&id=65b5cdfc&scoped=true"
import script from "./ExtraInformationForRide.vue?vue&type=script&lang=js"
export * from "./ExtraInformationForRide.vue?vue&type=script&lang=js"
import style0 from "./ExtraInformationForRide.vue?vue&type=style&index=0&id=65b5cdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5cdfc",
  null
  
)

export default component.exports